import Vue from 'vue';
export default function mixins() {
    var mixins = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        mixins[_i] = arguments[_i];
    }
    return Vue.extend({ mixins: mixins });
}
